<template>
  <div class="modal warning fade" :class="{'is-open': open}">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-body">
          <div class="warning　d-flex justify-content-between">
            <img
              width="48"
              :src="`${BaseUrl}assets/common/warning.png`"
              :srcset="`${BaseUrl}assets/common/warning@2x.png`"
            />
            <content>
              <slot name="content"></slot>
            </content>
          </div>
          <div class="action text-right">
            <a @click="$emit('close')" class="btn btn-default btn-custStyle">取消</a>
            <a ref="deleteBlur"  @click="confirmBlur" :class="!isFinalDelete?'btn-primary':'btn-red'" class="btn  btn-custStyle">{{`${!isFinalDelete?'確定':'確定解散'}`}}</a>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "mvDelete",
  computed: {
    ...mapGetters(["BaseUrl"]),
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    isFinalDelete: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    confirmBlur(e){
      this.$refs['deleteBlur'].blur()
      this.$emit('confirm')
    }
  },
};
</script>

<style lang="scss" scoped>
.btn-custStyle {
  padding-top:9px !important;
  width:120px;
  height: 40px;
}

button.btn.btn-red,
.btn.btn-red {
  &.is-hover,
  &.is-focus,
  &:hover,
  &:focus {
    background: #ffffff;
  }

  &.is-press,
  &:active {
    background: rgb(245, 197, 197);
  }
}


</style>
